__turbopack_context__.v({
  "main": "dashboard-module__61xrHq__main",
  "mainColumn": "dashboard-module__61xrHq__mainColumn",
  "shell": "dashboard-module__61xrHq__shell",
});
